import "./App.css"
import Home from './pages/Home'

const App = () => {
  return (
    <div className="container">
      <Home />
    </div>
  )
}

export default App
